import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ScrollableElement from '../components/ScrollableElement';


export default class ScrollableContainer extends Component{

    static propTypes = {
        onBottomReached: PropTypes.func
    }

    handleScroll = (e) => {
        const bottom = e.target.scrollHeight - e.target.scrollTop <= e.target.clientHeight + 1;
        if (bottom) {
            this.props.onBottomReached()
        }
    }

    render() {
        const {children} = this.props;
        return (
            <ScrollableElement onScroll={this.handleScroll}>
                {children}
            </ScrollableElement>
        );
    }

}